/* global __webpack_public_path__ */

let cache = null;

/** Cached runtime app settings. */
export function getAppSettings() {
  return cache || {};
}

/** Test seam for mutating the cached runtime app settings. */
export function setAppSettings(value) {
  cache = value;
}

/** Loads and caches appsettings.json from the remote's own origin. */
export async function loadAppSettings() {
  if (cache) return cache;

  let baseUrl = (typeof __webpack_public_path__ !== 'undefined' && __webpack_public_path__) || '/';
  if (!baseUrl.endsWith('/')) baseUrl += '/';

  try {
    const response = await fetch(`${baseUrl}appsettings.json`, { cache: 'no-store' });
    if (!response.ok) throw new Error(`appsettings.json ${response.status}`);
    const data = await response.json();
    if (!data || typeof data !== 'object' || Array.isArray(data)) {
      throw new Error('appsettings.json is not a JSON object');
    }
    cache = data;
  } catch (error) {
    console.error('[load-management-ui] failed to load appsettings.json', error);
    return {};
  }

  return cache;
}
